import React from 'react';

import * as S from './Loader.styles';

const Loader = ({variant = 'MAX', customClass = ''}) => {
  return <S.LoaderDiv top={'0%'} left={'15%'} />;
};

export default Loader;
